import { call, put } from 'redux-saga/effects';
import { AccessManagementService } from '../../../services/AccessManagement';
import { addToast } from '../toast/actions';
import { EToastTypes } from '../toast/types';
import { ECustomerUserPermissionType, IUser } from '../user/types';
import {
  createCustomerUserFailure,
  createCustomerUserSuccess,
  loadCustomerUsers,
  loadCustomerUsersFailure,
  loadCustomerUsersSuccess,
  removeCustomerUserFailure,
  removeCustomerUserSucess,
  updateCustomerUserPermissionFailure,
  updateCustomerUserPermissionSuccess
} from './actions';
import { Types } from './types';

interface ICreateUserCustomerParams {
  payload: {
    customerId: string;
    name: string;
    email: string;
    admin: boolean;
    fabricationPermission: boolean;

    ordersViewPermission: boolean;
    ordersViewPrice: boolean;
    financialViewPermission: boolean;
    orderInputPermission: boolean;

    coreTeam: boolean;
  };
  type: Types;
}

interface IUpdateCustomerUserPermissionParams {
  payload: {
    customerId: string;
    updatedUser: IUser;
    removeAllUserPermissions: boolean;
    customerUserPermissionType: ECustomerUserPermissionType;
    updateType: 'add' | 'remove';
  };
}

export function* loadCustomerUsersSaga(params: ICreateUserCustomerParams) {
  const accessManagementSvc = new AccessManagementService();
  try {
    const { customerId } = params.payload;
    const users: IUser[] = yield call(
      accessManagementSvc.getCustomerUsers.bind(accessManagementSvc),
      customerId
    );
    yield put(loadCustomerUsersSuccess(customerId, users));
  } catch (err) {
    console.error('loadCustomerUsersSaga', err);
    yield put(loadCustomerUsersFailure(err));
  }
}

export function* createCustomerUserSaga(params: ICreateUserCustomerParams) {
  const accessManagementSvc = new AccessManagementService();
  try {
    const {
      customerId,
      name,
      email,
      admin,
      fabricationPermission,
      ordersViewPermission,
      ordersViewPrice,
      financialViewPermission,
      orderInputPermission,

      coreTeam
    } = params.payload;

    yield call(
      accessManagementSvc.createCustomerUser.bind(accessManagementSvc),
      customerId,
      name,
      email,
      admin,
      fabricationPermission,
      ordersViewPermission,
      ordersViewPrice,
      financialViewPermission,
      orderInputPermission,
      coreTeam
    );

    yield put(createCustomerUserSuccess());
    yield put(
      addToast({
        message: 'Usuário criado com sucesso.',
        type: EToastTypes.SUCCESS,
        durationInMS: 5000,
        analyticsTag: {
          screenName: 'LG:GestaoDeUsuarios',
          itemName: 'sucess:usuario_adicionado_com_sucesso',
          event: 'success',
          itemDescription: 'gestaoDeUsuarios_usuarioAdicionadoComSucesso',
          nonInteraction: true
        }
      })
    );
  } catch (err) {
    console.error('createCustomerUserSaga', err);
    yield put(createCustomerUserFailure(err));
    yield put(
      addToast({
        message: 'Não foi possível adicionar o usuário.',
        type: EToastTypes.DANGER,
        durationInMS: 500000,
        analyticsTag: {
          screenName: 'LG:GestaoDeUsuarios:ModalAdicionarUsuario',
          itemName: 'error:falha_adicionar_usuario',
          event: 'error',
          itemDescription:
            'gestaoDeUsuarios_modalAdicionarUsuario_falhaAdicionarUsuario',
          nonInteraction: true
        }
      })
    );
  }
}

export function* updateCustomerUserPermissionSaga(
  params: IUpdateCustomerUserPermissionParams
) {
  const { customerId, updatedUser, customerUserPermissionType, updateType } =
    params.payload;
  try {
    const accessManagementSvc = new AccessManagementService();
    const user: IUser = yield accessManagementSvc.updateUserPermission(
      updatedUser,
      customerId,
      customerUserPermissionType,
      updateType
    );
    yield put(updateCustomerUserPermissionSuccess(user, customerId));
    yield put(
      addToast({
        message: `Usuário ${updatedUser.email} foi atualizado.`,
        type: EToastTypes.SUCCESS,
        durationInMS: 5000,
        analyticsTag: {
          screenName: 'LG:GestaoDeUsuarios',
          itemName: 'sucess:usuario_atualizado_com_sucesso',
          event: 'success',
          itemDescription: 'gestaoDeUsuarios_usuarioAtualizadoComSucesso',
          nonInteraction: true
        }
      })
    );
  } catch (err) {
    console.error('updateCustomerUserPermissionSaga', err);
    yield put(
      updateCustomerUserPermissionFailure(err, updatedUser, customerId)
    );
    yield put(
      addToast({
        message: `Falha ao atualizar o usuário ${updatedUser.email}.`,
        type: EToastTypes.DANGER,
        durationInMS: 5000
      })
    );
  }
}

export function* removeCustomerUserSaga(
  params: IUpdateCustomerUserPermissionParams
) {
  const { customerId, updatedUser } = params.payload;
  try {
    const accessManagementSvc = new AccessManagementService();
    yield accessManagementSvc.removeUserFromCustomer(updatedUser, customerId);
    yield put(removeCustomerUserSucess());
    yield put(
      addToast({
        message: `Usuário ${updatedUser.email} removido com sucesso.`,
        type: EToastTypes.SUCCESS,
        durationInMS: 5000,
        analyticsTag: {
          screenName: 'LG:GestaoDeUsuarios',
          itemName: 'sucess:usuario_removido_com_sucesso',
          event: 'success',
          itemDescription: 'gestaoDeUsuarios_usuarioRemovidoComSucesso',
          nonInteraction: true
        }
      })
    );

    yield put(loadCustomerUsers(customerId));
  } catch (err) {
    console.error('removeCustomerUserSaga', err);
    yield put(removeCustomerUserFailure(err));
    yield put(
      addToast({
        message: `Falha ao remover o usuário ${updatedUser.email}.`,
        type: EToastTypes.DANGER,
        durationInMS: 5000
      })
    );
  }
}
